var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wpArea" }, [
    _c(
      "div",
      { staticClass: "area-content" },
      [
        _c("h2", { staticClass: "normal" }, [_vm._v("编辑板块")]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("板块名："),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.area_name,
                expression: "area_name"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.area_name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.area_name = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "el-radio",
          {
            attrs: { label: "板块" },
            model: {
              value: _vm.level,
              callback: function($$v) {
                _vm.level = $$v
              },
              expression: "level"
            }
          },
          [_vm._v("板块")]
        ),
        _vm._v(" "),
        _c(
          "el-radio",
          {
            attrs: { label: "区域" },
            model: {
              value: _vm.level,
              callback: function($$v) {
                _vm.level = $$v
              },
              expression: "level"
            }
          },
          [_vm._v("区域")]
        ),
        _vm._v(" "),
        _c(
          "el-radio",
          {
            attrs: { label: "其它" },
            model: {
              value: _vm.level,
              callback: function($$v) {
                _vm.level = $$v
              },
              expression: "level"
            }
          },
          [_vm._v("其它")]
        ),
        _vm._v(" "),
        _c(
          "el-radio",
          {
            attrs: { label: "职住平衡" },
            model: {
              value: _vm.level,
              callback: function($$v) {
                _vm.level = $$v
              },
              expression: "level"
            }
          },
          [_vm._v("职住平衡")]
        ),
        _vm._v(" "),
        _c(
          "el-radio",
          {
            attrs: { label: "备份" },
            model: {
              value: _vm.level,
              callback: function($$v) {
                _vm.level = $$v
              },
              expression: "level"
            }
          },
          [_vm._v("备份")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("行政区划："),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.district,
                expression: "district"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.district },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.district = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("板块等级："),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.area_level,
                expression: "area_level"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.area_level },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.area_level = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("板块介绍："),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.area_des,
                expression: "area_des"
              }
            ],
            attrs: { rows: "5", cols: "50" },
            domProps: { value: _vm.area_des },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.area_des = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("产业性质："),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.nature,
                expression: "nature"
              }
            ],
            attrs: { type: "text", placeholder: "例如高新产业、服务业" },
            domProps: { value: _vm.nature },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.nature = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("规划等级："),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.plan_level,
                expression: "plan_level"
              }
            ],
            attrs: { type: "text", placeholder: "例如国家级、省级" },
            domProps: { value: _vm.plan_level },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.plan_level = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("建筑体量(万方)："),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.square,
                expression: "square"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.square },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.square = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("规划人口(万人)："),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.population,
                expression: "population"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.population },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.population = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("热度排名："),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.hot,
                expression: "hot"
              }
            ],
            attrs: { type: "number" },
            domProps: { value: _vm.hot },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.hot = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("新房价格："),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.new_price,
                expression: "new_price"
              }
            ],
            attrs: { type: "number" },
            domProps: { value: _vm.new_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.new_price = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "normal" },
          [
            _vm._v("事件日期：\n      "),
            _c(
              "div",
              { staticStyle: { width: "200px", display: "inline-block" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "格式: 2020-4-9" },
                  model: {
                    value: _vm.trendDate,
                    callback: function($$v) {
                      _vm.trendDate = $$v
                    },
                    expression: "trendDate"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { type: "info" }, on: { click: _vm.addEvent } },
              [_vm._v("添加")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "normal text" }, [
          _c("span", [_vm._v("事件描述：")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "inputBox" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  autosize: "",
                  placeholder: "请输入描述"
                },
                model: {
                  value: _vm.trendEvent,
                  callback: function($$v) {
                    _vm.trendEvent = $$v
                  },
                  expression: "trendEvent"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("button", { staticClass: "up", on: { click: _vm.upToDb } }, [
          _vm._v("上传")
        ]),
        _vm._v(" "),
        _vm.selfTrend.length > 0
          ? _c(
              "div",
              { staticStyle: { width: "980px", margin: "30px auto" } },
              [
                _c("h3", [_vm._v("时间轴")]),
                _vm._v(" "),
                _c(
                  "el-table",
                  { attrs: { data: _vm.selfTrend, border: "", stripe: "" } },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "event", label: "事件" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "date", label: "日期", width: "90" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "80" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.delOneTrend(scope.$index)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1761412900
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.news.length > 0
          ? _c(
              "div",
              { staticStyle: { width: "750px", margin: "30px auto" } },
              [
                _c("h3", [_vm._v("相关文章")]),
                _vm._v(" "),
                _c(
                  "el-table",
                  { attrs: { data: _vm.news, border: "", stripe: "" } },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "title", label: "标题" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "date", label: "日期", width: "90" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "220" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "warning" },
                                    on: {
                                      click: function($event) {
                                        return _vm.unBind(
                                          scope.row,
                                          scope.$index
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("解绑")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function($event) {
                                        return _vm.passOneNews(
                                          scope.row,
                                          scope.$index
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("排除")]
                                ),
                                _vm._v(" "),
                                scope.row.summary
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "text" },
                                        on: {
                                          click: function($event) {
                                            _vm.currentNews = scope.row
                                          }
                                        }
                                      },
                                      [_vm._v("已编辑")]
                                    )
                                  : _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.currentNews = scope.row
                                          }
                                        }
                                      },
                                      [_vm._v("编辑")]
                                    )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        724171718
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentNews
          ? _c("div", { staticClass: "image-background" }, [
              _c("div", { staticClass: "edit-area" }, [
                _c("div", { staticClass: "edit-left" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.currentNews.content) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentNews.summary,
                      expression: "currentNews.summary"
                    }
                  ],
                  staticClass: "edit-right",
                  domProps: { value: _vm.currentNews.summary },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.currentNews, "summary", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "warning" },
                      on: {
                        click: function($event) {
                          _vm.currentNews = null
                        }
                      }
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.saveEdit }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa455786", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa455786","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/wpArea.vue
// module id = null
// module chunks = 